// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgStatusApprovedSolid = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m14.678 2.843 2.091-.308c1.03-.151 1.989.574 2.168 1.64l.365 2.166 1.866 1.03c.918.508 1.285 1.681.828 2.653L21.07 12l.927 1.976c.457.972.09 2.145-.828 2.652l-1.866 1.031-.365 2.166c-.18 1.066-1.138 1.791-2.168 1.64l-2.091-.308-1.518 1.529a1.872 1.872 0 0 1-2.68 0l-1.518-1.53-2.092.309c-1.029.151-1.988-.574-2.168-1.64l-.365-2.166-1.866-1.03c-.918-.508-1.284-1.681-.828-2.653L2.571 12l-.928-1.976c-.456-.972-.09-2.145.828-2.652L4.337 6.34l.365-2.166c.18-1.066 1.14-1.791 2.168-1.64l2.092.308 1.518-1.529a1.873 1.873 0 0 1 2.68 0zM10.207 15.87l6.074-6.48a.466.466 0 0 0 .001-.628l-.587-.63a.398.398 0 0 0-.59-.002l-5.192 5.54-1.863-1.98a.398.398 0 0 0-.588.001l-.586.625a.465.465 0 0 0 0 .628l2.742 2.926a.398.398 0 0 0 .589 0z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgStatusApprovedSolid;
